// extracted by mini-css-extract-plugin
export var bannerContent = "banner-content";
export var subheading = "subheading";
export var fadeIn = "fadeIn";